import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import { __assign, __awaiter, __generator, __values } from "tslib";
import Vue from 'vue';
import { serverDateNow, dateParse, isUndef, dateFormat, dateOffset, dateNow, wait } from '@/lib/utils';
import { chooseWXPay } from '@/lib/script/pay';
import { ActiveActivityId, STATIC_HOST } from '@/lib/constant';
/** 可换套餐期限 */

function upgradeDeadline(basicInfo) {
  var joined = basicInfo ? basicInfo.joined : false;

  if (joined && basicInfo.can_change_package) {
    var now = dateNow().getTime();
    var threeDays = dateOffset(dateParse(basicInfo.join_time), 3);
    var finish = threeDays.getTime();
    var leftSecond = Math.floor((finish - now) / 1000);

    if (leftSecond > 0) {
      var arr = dateFormat(threeDays).split('-');
      return "\u9650" + Number(arr[1]) + "\u6708" + Number(arr[2]) + "\u65E5\u524D";
    } else {
      return null;
    }
  } else {
    return null;
  }
}

var m = {
  namespaced: true,
  state: function state() {
    return {
      Optional_goods: [],
      activityId: '',
      basicInfo: {},
      activityIdMapLevels: {},
      teamListRequesting: false,
      team: {
        card: {},
        detail: {},
        detailPromise: {}
      },
      topicId: '',
      keyword: '',
      searchResult: {},
      searchRequesting: false,
      teamList: {},
      comments: {},
      activityNews: {},
      newsRequesing: false,
      packageMap: {},
      activityPackages: {},
      giftMap: {},
      activityGift: {},
      activityAd: {},
      personalInviteCard: {},
      recruitStatMap: {},
      activityTipsMap: {},
      shareWord: {},
      participationInfo: {},
      participationList: null,
      registrationMap: {},
      categoryList: null,
      questionList: {},
      achievementMap: {},
      indexData: {
        sign_in_count: 0,
        insist_count: 0,
        team_count: 0
      },
      registrationOpenInfo: [],
      bannerInfo: null,
      activityListBanner: null,
      joinHint: true,
      report10: null,
      report11: null,
      report: {},
      runners: {
        list: [],
        requesting: false,
        loaded: false
      },
      isSelectedAgreement: false,
      currentTeam: {},
      story: null,
      memberList: {},
      monitorList: {},
      homePage: null,
      hasJump: false,
      searchUser: {},
      special_type: '',
      selectSkuMap: null
    };
  },
  getters: {
    /** 主要的活动id */
    activityId: function activityId() {
      //   return '31';
      return ActiveActivityId;
    },

    /** 邀请活动id，邀请卡页面中使用的活动id */
    inviteActivityId: function inviteActivityId() {
      return ActiveActivityId;
    },

    /** @deprecated 打卡活动id，打卡页面中使用的活动id */
    signInActivityId: function signInActivityId() {
      return ActiveActivityId;
    },

    /** 队长活动id */
    monitorActivityId: function monitorActivityId() {
      return ActiveActivityId;
    },

    /** 当前所有执行中的活动 */
    activityIds: function activityIds() {
      return [];
      return ['31', '24'];
    },

    /** 所有活动，可以在活动列表中使用，不需要显示的可以隐藏 */
    allActivityIds: function allActivityIds() {
      return ['60', '54', '24', '6', '5', '4', '3', '2'];
    },

    /** 所有管理的战队活动id，将在战队管理列表中显示 */
    allMonitorActivityIds: function allMonitorActivityIds() {
      return ['60', '54', '24', '6', '5', '4', '3'];
    }
  },
  mutations: {
    Optional_goods: function Optional_goods(state, data) {
      state.Optional_goods = data;
    },
    getTopicId: function getTopicId(state, data) {
      // 从成功页获取专题id
      state.topicId = data; // state.topicId = data
    },
    // activityId(state,data){
    //   state.topicId = data
    // },
    special_type: function special_type(state, data) {
      state.special_type = data;
      localStorage.setItem('activityId', data);
    },
    setActivityId: function setActivityId(state, activityId) {
      state.activityId = activityId;
    },
    setRegistrationMap: function setRegistrationMap(state, _a) {
      var activityId = _a.activityId,
          info = _a.info;
      Vue.set(state.registrationMap, activityId, info);
    },
    setBasicInfo: function setBasicInfo(state, _a) {
      var _b, _c, _d, _e, _f, _g, _h, _j, _k;

      var activityId = _a.activityId,
          basicInfo = _a.basicInfo;

      if (basicInfo) {
        var serverDate = (_b = serverDateNow()) === null || _b === void 0 ? void 0 : _b.valueOf();
        basicInfo.id = activityId;
        basicInfo.startParticipation = basicInfo ? serverDate >= ((_c = dateParse(basicInfo.sign_up_open_time)) === null || _c === void 0 ? void 0 : _c.valueOf()) : false;
        basicInfo.closeParticipation = basicInfo ? serverDate >= ((_d = dateOffset(dateParse(basicInfo.sign_up_finish_date), 1)) === null || _d === void 0 ? void 0 : _d.valueOf()) : false;
        basicInfo.realCloseParticipation = basicInfo ? serverDate >= ((_e = dateOffset(dateParse(basicInfo.sign_up_real_finish_date), 1)) === null || _e === void 0 ? void 0 : _e.valueOf()) : false;
        basicInfo.startMonitorApply = basicInfo ? serverDate >= ((_f = dateParse(basicInfo.monitor_apply_start_date)) === null || _f === void 0 ? void 0 : _f.valueOf()) : false;
        basicInfo.closeMonitorApply = basicInfo ? serverDate >= ((_g = dateOffset(dateParse(basicInfo.monitor_apply_finish_date), 1)) === null || _g === void 0 ? void 0 : _g.valueOf()) : false;
        basicInfo.startSignIn = basicInfo ? serverDate >= ((_h = dateParse(basicInfo.sign_in_start_date)) === null || _h === void 0 ? void 0 : _h.valueOf()) : false;
        basicInfo.closeSignIn = basicInfo ? serverDate >= ((_j = dateOffset(dateParse(basicInfo.sign_in_finish_date), 1)) === null || _j === void 0 ? void 0 : _j.valueOf()) : false;
        basicInfo.openSignUp = basicInfo ? serverDate >= ((_k = dateParse(basicInfo.sign_up_open_time)) === null || _k === void 0 ? void 0 : _k.valueOf()) : false; // @deprecated: 不要再使用

        basicInfo.joinedTeamId = basicInfo && basicInfo.joined && basicInfo.team_id ? String(basicInfo.team_id) : null;
        basicInfo.upgradeDeadline = upgradeDeadline(basicInfo);
      }

      Vue.set(state.basicInfo, activityId, basicInfo);
    },
    setLevels: function setLevels(state, _a) {
      var activityId = _a.activityId,
          levels = _a.levels;
      Vue.set(state.activityIdMapLevels, activityId, levels);
    },
    setSearchRequesing: function setSearchRequesing(state, requesting) {
      state.searchRequesting = requesting;
    },
    setSearchKeyWord: function setSearchKeyWord(state, keyword) {
      state.keyword = keyword;
    },
    setSearchResult: function setSearchResult(state, _a) {
      var name = _a.name,
          data = _a.data;
      var ids = [];
      data.forEach(function (team) {
        Vue.set(state.team.card, team.id, team);
        ids.push(team.id);
      });
      state.searchResult[name].list = state.searchResult[name].list.concat(ids);
    },
    setSearchResultLoaded: function setSearchResultLoaded(state, _a) {
      var name = _a.name,
          val = _a.val;
      Vue.set(state.searchResult[name], 'loaded', val);
    },
    initTeamList: function initTeamList(state, key) {
      Vue.set(state.teamList, key, {
        list: [],
        loaded: false
      });
    },
    setTeamListRequesting: function setTeamListRequesting(state, val) {
      state.teamListRequesting = val;
    },
    setTeamList: function setTeamList(state, _a) {
      var key = _a.key,
          data = _a.data;
      var list = [];
      (data || []).forEach(function (item) {
        Vue.set(state.team.card, item.id, item);
        list.push(item.id);
      });
      state.teamList[key].list = state.teamList[key].list.concat(list);
    },
    setTeamListLoaded: function setTeamListLoaded(state, _a) {
      var key = _a.key,
          val = _a.val;
      Vue.set(state.teamList[key], 'loaded', val);
    },
    setComments: function setComments(state, _a) {
      var activityId = _a.activityId,
          data = _a.data;
      Vue.set(state.comments, activityId, data);
    },
    setNews: function setNews(state, _a) {
      var activityId = _a.activityId,
          news = _a.news;
      var list = state.activityNews[activityId].list; // const basicInfo = state.basicInfo[activityId];
      // const num = basicInfo ? basicInfo!.total_join_count : 0;
      // const top = {
      //     id: 0,
      //     title: `第十届百日跑总人数突破${num}人！`,
      //     time: dateFormat(dateToday(), null),
      //     link: null, // 如果不存在链接此字段为null
      // };
      // if (list.length === 0 && news.length > 0) {
      //     news.unshift(top);
      // } else if (list.length === 0 && news.length === 0) {
      //     news[0] = top;
      // } else if (state.basicInfo && list.length > 0 && list[0].id === 0) {
      //     list[0] = top;
      // }

      state.activityNews[activityId].list = list.concat(news);
    },
    setNewsRequesting: function setNewsRequesting(state, requesting) {
      state.newsRequesing = requesting;
    },
    setNewsLoaded: function setNewsLoaded(state, _a) {
      var activityId = _a.activityId,
          val = _a.val;
      Vue.set(state.activityNews[activityId], 'loaded', val);
    },

    /** 记录战队详情 */
    setTeamDetail: function setTeamDetail(state, _a) {
      var teamId = _a.teamId,
          data = _a.data;
      data.id = teamId;
      Vue.set(state.team.detail, teamId, data);
    },

    /** 记录战队详情 */
    setTeamDetailPromise: function setTeamDetailPromise(state, _a) {
      var teamId = _a.teamId,
          data = _a.data;
      Vue.set(state.team.detailPromise, teamId, data);
    },

    /**
     * 记录礼包信息
     */
    setActivityPackage: function setActivityPackage(state, _a) {
      var key = _a.key,
          data = _a.data;
      var ids = [];
      data.forEach(function (pack) {
        var e_1, _a;

        if (pack) {
          if (pack.gift_info) {
            try {
              for (var _b = __values(pack.gift_info), _c = _b.next(); !_c.done; _c = _b.next()) {
                var gift = _c.value;
                gift.specification = null;
              }
            } catch (e_1_1) {
              e_1 = {
                error: e_1_1
              };
            } finally {
              try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
          }

          Vue.set(state.packageMap, pack.id, pack);
          ids.push(pack.id);
        }
      });
      Vue.set(state.activityPackages, key, ids);
    },
    setActivityGift: function setActivityGift(state, _a) {
      var activityId = _a.activityId,
          data = _a.data;
      data.gifts.forEach(function (item) {
        Vue.set(state.giftMap, item.id, item);
      });
      Vue.set(state.activityGift, activityId, data);
    },

    /**
     * 记录活动广告
     */
    setActivityAd: function setActivityAd(state, _a) {
      var activityId = _a.activityId,
          adType = _a.adType,
          data = _a.data;
      Vue.set(state.activityAd, [activityId, adType].join('_'), data);
    },
    setPersonalInviteCard: function setPersonalInviteCard(state, _a) {
      var activityId = _a.activityId,
          card = _a.card;
      Vue.set(state.personalInviteCard, activityId, card);
    },

    /**
     * 记录总招募信息
     */
    setRecruitStat: function setRecruitStat(state, _a) {
      var activityId = _a.activityId,
          recruitStat = _a.recruitStat;
      Vue.set(state.recruitStatMap, activityId, recruitStat);
    },
    setActivityTipsMap: function setActivityTipsMap(state, _a) {
      var activityId = _a.activityId,
          list = _a.list;
      Vue.set(state.activityTipsMap, activityId, list);
    },

    /**
     * 记录分享话术
     */
    setShareWord: function setShareWord(state, _a) {
      var activityId = _a.activityId,
          kind = _a.kind,
          shareWord = _a.shareWord;
      Vue.set(state.shareWord, [activityId, kind].join('_'), shareWord);
    },
    setCategoryList: function setCategoryList(state, categoryList) {
      state.categoryList = categoryList;
    },

    /**
     * 获得问题列表
     */
    setQuestionList: function setQuestionList(state, _a) {
      var categoryId = _a.categoryId,
          questionList = _a.questionList;
      Vue.set(state.questionList, categoryId, questionList);
    },

    /** 记录完赛总结数据 */
    setAchievementMap: function setAchievementMap(state, _a) {
      var activityId = _a.activityId,
          userId = _a.userId,
          summary = _a.summary;

      if (summary && summary.recollection && summary.recollections) {
        summary.recollections.unshift(summary.recollection);
      }

      Vue.set(state.achievementMap[activityId], userId, summary);
    },

    /** 设置610首页展示数据 */
    setIndexData: function setIndexData(state, data) {
      state.indexData = data;
    },

    /** 设置610首页banner信息 */
    setBannerInfo: function setBannerInfo(state, info) {
      state.bannerInfo = info;
    },

    /** 设置610首页banner信息 */
    setActivityListBanner: function setActivityListBanner(state, banner) {
      state.activityListBanner = banner;
    },

    /** 设置610首页报名开启信息 */
    setRegistrationOpenInfo: function setRegistrationOpenInfo(state, info) {
      state.registrationOpenInfo = info;
    },

    /**
     * 设置joinHint是否可见
     */
    setJoinHintVisible: function setJoinHintVisible(state, visible) {
      state.joinHint = visible;
    },

    /** 设置完赛10 */
    setReport10: function setReport10(state, data) {
      state.report10 = data;
    },

    /** 设置完赛11 */
    setReport11: function setReport11(state, data) {
      state.report11 = data;
    },

    /** 设置用户 */
    setRunners: function setRunners(state, data) {
      state.runners.list = state.runners.list.concat(data);
    },

    /** 用户请求 */
    setRunnersRequest: function setRunnersRequest(state, data) {
      state.runners.requesting = data;
    },

    /** 用户加载 */
    setRunnersLoaded: function setRunnersLoaded(state, data) {
      state.runners.loaded = data;
    },

    /** 同意用户协议 */
    setSelectAgreement: function setSelectAgreement(state, data) {
      state.isSelectedAgreement = data;
    },
    setCurrentTeam: function setCurrentTeam(state, _a) {
      var userId = _a.userId,
          team = _a.team;
      Vue.set(state.currentTeam, userId, team);
    },
    setStory: function setStory(state, list) {
      state.story = list;
    },
    setHasJump: function setHasJump(state, hasJump) {
      state.hasJump = hasJump;
    },

    /**
     * 搜索用户结果
     */
    initSearchUser: function initSearchUser(state, _a) {
      var key = _a.key;
      Vue.set(state.searchUser, key, {
        list: [],
        loaded: false,
        requesting: false
      });
    },
    concatSearchUser: function concatSearchUser(state, _a) {
      var key = _a.key,
          list = _a.list;
      state.searchUser[key].list = state.searchUser[key].list.concat(list);
    },
    setSearchUserLoaded: function setSearchUserLoaded(state, _a) {
      var key = _a.key,
          loaded = _a.loaded;
      state.searchUser[key].loaded = loaded;
    },
    setSearchUserReq: function setSearchUserReq(state, _a) {
      var key = _a.key,
          req = _a.req;
      state.searchUser[key].requesting = req;
    },
    setSelectSkuMap: function setSelectSkuMap(state, map) {
      state.selectSkuMap = map;
    }
  },
  actions: {
    upData: function upData(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var data = _b.data,
          id = _b.id,
          team_id = _b.team_id;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/bind_user_participation', {
                user_id: data,
                activity_id: id,
                team_id: team_id
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              ];
          }
        });
      });
    },

    /** 获取610首页展示数据 */
    getIndexData: function getIndexData(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/external/pc/index')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setIndexData', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /** 获取610首页banner轮播图信息及点击跳转链接 */
    getBannerInfo: function getBannerInfo(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var forceUpdate = (_b === void 0 ? {} : _b).forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              // 缓存
              if (state.bannerInfo && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/web/image')];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setBannerInfo', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getActivityListBanner: function getActivityListBanner(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var forceUpdate = (_b === void 0 ? {} : _b).forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.bannerInfo && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/banner')];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setActivityListBanner', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取活动报名情况
     * @param activityId
     * @param forceUpdate
     */
    getRegistration: function getRegistration(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.registrationMap[activityId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/info', {
                params: {
                  activity_id: String(activityId)
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setRegistrationMap', {
                  activityId: activityId,
                  info: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取活动基本信息
     * @param activityId
     * @param forceUpdate
     */
    getBasicInfo: function getBasicInfo(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          forceUpdate = _b.forceUpdate,
          activitySpecialId = _b.activitySpecialId,
          formPath = _b.formPath;
      return __awaiter(this, void 0, void 0, function () {
        var data, response, rdata, basicInfo, url;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              data = state.basicInfo[activityId];

              if (data && !forceUpdate && String(activitySpecialId) === String(data.activity_special_id) || !activityId) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/activity_info', {
                params: {
                  id: activityId + '',
                  activity_special_id: activitySpecialId ? activitySpecialId : undefined,
                  form_path: formPath || location.href
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                basicInfo = rdata.data;
                url = {
                  1: STATIC_HOST + '/meta/activity_1/main_banner.png',
                  2: STATIC_HOST + '/activity_cover_image/2019-08-04-23-01-47/a3d9f183328042d89bb62af03ac9dde5.jpg',
                  3: STATIC_HOST + '/meta/activity_3/main_banner.jpg',
                  4: STATIC_HOST + '/meta/activity_4/activity_list_banner.jpg',
                  5: STATIC_HOST + '/meta/activity_5/activity_list_banner.png',
                  6: STATIC_HOST + '/meta/activity_6/activity_list_banner.jpg'
                };
                basicInfo.cover = url[Number(activityId)];
                commit('setBasicInfo', {
                  activityId: activityId,
                  basicInfo: rdata.data
                });
                commit('topicId', {
                  topicId: rdata.data.activity_special_type
                });

                if (activitySpecialId) {
                  commit('special_type', rdata.data.activity_special_type); // localStorage.setItem(
                  //   "activityId",
                  //   rdata.data.activity_special_type
                  // );
                } // gio('people.set', 'activity_' + activityId, rdata.data.joined ? '1' : '0');

              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取组别列表
     * @param activityId
     * @param cityId
     */
    getLevels: function getLevels(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          cityId = _b.cityId,
          activitySpecialId = _b.activitySpecialId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/level_list', {
                params: {
                  id: activityId,
                  city_id: cityId,
                  activity_special_id: activitySpecialId ? activitySpecialId : undefined
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setLevels', {
                  activityId: activityId,
                  levels: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取某个级别下的战队列表
     * @param activityId
     * @param levelId
     * @param cityId
     * @param count
     * @param offset
     * @param type 当为非空情况下，将不再显示已经满百战队
     * @param forceUpdate
     */
    getTeamList: function getTeamList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          levelId = _b.levelId,
          count = _b.count,
          offset = _b.offset,
          cityId = _b.cityId,
          disShowFullTeam = _b.disShowFullTeam,
          forceUpdate = _b.forceUpdate,
          activitySpecialId = _b.activitySpecialId,
          name = _b.name;
      return __awaiter(this, void 0, void 0, function () {
        var key, wrap, end, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              key = activitySpecialId ? activityId + "_" + levelId + "_" + activitySpecialId : activityId + "_" + levelId;
              wrap = state.teamList[key];
              console.log('target 请求key', key, wrap);

              if (!activityId) {
                return [2
                /*return*/
                ];
              }

              if (isUndef(wrap)) {
                commit('initTeamList', key);
                wrap = state.teamList[key];
              }

              if (wrap.loaded && !forceUpdate || state.teamListRequesting) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate && wrap) {
                wrap.list = [];
                wrap.loaded = false;
              }

              end = offset + count;

              if (end <= wrap.list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < wrap.list.length) {
                offset = wrap.list.length;
                count = end - offset;
              }

              commit('setTeamListRequesting', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/team_list', {
                params: {
                  id: activityId,
                  activity_special_id: activitySpecialId,
                  city_id: cityId,
                  level_id: levelId,
                  count: count,
                  offset: offset,
                  name: name,
                  dis_show_full_team: disShowFullTeam ? 1 : 0
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setTeamList', {
                  key: key,
                  data: rdata.data
                });

                if (rdata.data.length < count) {
                  commit('setTeamListLoaded', {
                    key: key,
                    val: true
                  });
                }
              }

              commit('setTeamListRequesting', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 搜索战队
     * @param activityId string
     * @param count number
     * @param offset number
     * @param name string 搜索内容
     * @param forceUpdate boolean
     */
    searchTeam: function searchTeam(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          count = _b.count,
          offset = _b.offset,
          name = _b.name,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c,
          activitySpecialId = _b.activitySpecialId;
      return __awaiter(this, void 0, void 0, function () {
        var tempData, end, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              tempData = state.searchResult[name];

              if (isUndef(tempData)) {
                Vue.set(state.searchResult, name, {
                  list: [],
                  loaded: false
                });
              }

              if (tempData && tempData.loaded && !forceUpdate || state.searchRequesting) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate && tempData) {
                tempData.list = [];
                tempData.loaded = false;
              }

              end = offset + count;

              if (tempData && end <= tempData.list.length) {
                return [2
                /*return*/
                ];
              }

              if (tempData && offset < tempData.list.length) {
                offset = tempData.list.length;
                count = end - offset;
              }

              commit('setSearchRequesing', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/search_team', {
                params: {
                  id: activityId,
                  activity_special_id: activitySpecialId,
                  count: count,
                  offset: offset,
                  name: name
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;
              commit('setSearchRequesing', false);

              if (rdata.status === 0) {
                commit('setSearchKeyWord', name);
                commit('setSearchResult', {
                  name: name,
                  data: rdata.data
                });

                if (rdata.data.length < count) {
                  commit('setSearchResultLoaded', {
                    name: name,
                    val: true
                  });
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 搜索用户
     */
    searchUser: function searchUser(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var name = _b.name,
          offset = _b.offset,
          count = _b.count;
      return __awaiter(this, void 0, void 0, function () {
        var key, wrap, end, len, response, rdata, list;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              key = name;
              wrap = state.searchUser[key];

              if (!wrap) {
                commit('initSearchUser', {
                  key: key
                });
                wrap = state.searchUser[key];
              }

              if (wrap.requesting || wrap.loaded) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;
              len = wrap.list.length;

              if (end <= len) {
                return [2
                /*return*/
                ];
              }

              if (offset < len) {
                offset = len;
                count = end - offset;
              }

              commit('setSearchUserReq', {
                key: key,
                req: true
              });
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/search_user', {
                params: {
                  name: name,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                list = rdata.data;
                commit('concatSearchUser', {
                  key: key,
                  list: list
                });

                if (list.length < count) {
                  commit('setSearchUserLoaded', {
                    key: key,
                    loaded: true
                  });
                }
              }

              commit('setSearchUserReq', {
                key: key,
                req: false
              });
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取跑友说内容
     * @param activityId
     */
    getComments: function getComments(_a, activityId) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var tempData, response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              tempData = state.comments[activityId];

              if (!isUndef(tempData)) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/activity_comment', {
                params: {
                  id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setComments', {
                  activityId: activityId,
                  data: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 最新战报
     * @param activityId
     * @param count
     * @param lastId
     * @param forceUpdate
     */
    getNews: function getNews(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          count = _b.count,
          lastId = _b.lastId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var tempData, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (isUndef(state.activityNews[activityId])) {
                Vue.set(state.activityNews, activityId, {
                  list: [],
                  loaded: false
                });
              }

              tempData = state.activityNews[activityId];

              if (state.newsRequesing || tempData && tempData.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate && tempData) {
                tempData.loaded = false;
                tempData.list = [];
                lastId = null;
              }

              commit('setNewsRequesting', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/news', {
                params: {
                  id: activityId,
                  last_id: lastId,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;
              commit('setNewsRequesting', false);

              if (rdata.status === 0) {
                commit('setNews', {
                  activityId: activityId,
                  news: rdata.data
                });

                if (rdata.data.length < count) {
                  commit('setNewsLoaded', {
                    activityId: activityId,
                    val: true
                  });
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取战队详情
     * @param teamId
     */
    getTeamDetail: function getTeamDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var teamId = _b.teamId,
          forceUpdate = _b.forceUpdate,
          formPath = _b.formPath;
      return __awaiter(this, void 0, void 0, function () {
        var detail, detailPromise, promise, response, rdata, data;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              detail = state.team.detail[teamId];
              detailPromise = state.team.detailPromise[teamId];

              if ((!isUndef(detail) || !isUndef(detailPromise)) && !forceUpdate) {
                return [2
                /*return*/
                , detail || detailPromise];
              }

              promise = Vue.axios.get('/api/v1/activity/team_info', {
                params: {
                  id: teamId,
                  form_path: formPath || location.href
                }
              });
              commit('setTeamDetailPromise', {
                teamId: teamId,
                data: promise
              });
              return [4
              /*yield*/
              , promise];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('setTeamDetail', {
                  teamId: teamId,
                  data: data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取其他的未满百的战队
     * @param teamId
     */
    getAnotherTeamDetail: function getAnotherTeamDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          teamId = _b.teamId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, data;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/another_not_full_team', {
                params: {
                  id: activityId,
                  team_id: teamId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;

                if (data && data.id) {
                  commit('setTeamDetail', {
                    teamId: data.id,
                    data: data
                  });
                }
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取活动套餐
     * @param {String} activiyId 活动id
     */
    getPackage: function getPackage(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          activitySpecialId = _b.activitySpecialId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var key, response, rdata, data;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              key = "" + activityId;

              if (!isUndef(activitySpecialId)) {
                key = key + "_" + activitySpecialId;
              }

              if (state.activityPackages[key] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/package_list', {
                params: {
                  id: activityId,
                  activity_special_id: activitySpecialId,
                  v: 1
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('setActivityPackage', {
                  key: key,
                  data: data
                });
                commit('Optional_goods', data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    // 更新数据

    /**
     * 升级套餐
     * @param participationId 订单id
     * @param packageId 套餐id
     */
    changePackage: function changePackage(_a, _b) {
      var state = _a.state,
          commit = _a.commit,
          dispatch = _a.dispatch;
      var participationId = _b.participationId,
          packageId = _b.packageId,
          specifications = _b.specifications;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, data, orderId, payResponse, payRdata, ret, result, msg, i, rdata_1;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/change_package', {
                id: participationId,
                package_id: packageId,
                specifications: specifications
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              if (!(rdata.status === 0)) return [3
              /*break*/
              , 14];
              data = rdata.data;
              if (!(data.type === 'upgrade')) return [3
              /*break*/
              , 12];
              orderId = data.order.id;
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/pay', {
                order_id: orderId,
                type: 'upgrade'
              })];

            case 2:
              payResponse = _c.sent();
              payRdata = payResponse.data;

              if (payRdata.status !== 0) {
                return [2
                /*return*/
                , {
                  status: -1,
                  message: payRdata.message
                }];
              }

              return [4
              /*yield*/
              , chooseWXPay(payRdata.data.params)];

            case 3:
              ret = _c.sent(); // 支付失败

              if (ret.status !== 'success') {
                return [2
                /*return*/
                , {
                  status: -1,
                  message: ret.status === 'cancel' ? '支付取消' : ret.result
                }];
              }

              result = null;
              msg = null;
              i = 30;
              _c.label = 4;

            case 4:
              if (!(i > 0)) return [3
              /*break*/
              , 11];
              return [4
              /*yield*/
              , dispatch('payStatus', {
                orderId: orderId,
                type: 'upgrade_order'
              }, {
                root: true
              })];

            case 5:
              rdata_1 = _c.sent();
              if (!(rdata_1.status !== 0 || !rdata_1.data)) return [3
              /*break*/
              , 6]; // 错误，结束

              result = false;
              msg = rdata_1.message;
              return [3
              /*break*/
              , 11];

            case 6:
              if (!(rdata_1.data.finished === true)) return [3
              /*break*/
              , 7]; // 成功

              result = true;
              return [3
              /*break*/
              , 11];

            case 7:
              if (!(rdata_1.data.finished === false)) return [3
              /*break*/
              , 9]; // 等待

              return [4
              /*yield*/
              , wait(1000)];

            case 8:
              // 等待
              _c.sent();

              return [3
              /*break*/
              , 10];

            case 9:
              result = false;
              _c.label = 10;

            case 10:
              i--;
              return [3
              /*break*/
              , 4];

            case 11:
              if (result === false) {
                return [2
                /*return*/
                , {
                  status: -1,
                  message: msg || '发生了未知错误'
                }];
              } else if (result === true) {
                return [2
                /*return*/
                , {
                  status: 0,
                  message: 'OK',
                  data: orderId
                }];
              } else {
                return [2
                /*return*/
                , {
                  status: -1,
                  message: '系统繁忙，请稍后再试',
                  data: orderId
                }];
              }

              return [3
              /*break*/
              , 13];

            case 12:
              return [2
              /*return*/
              , __assign({
                status: 0
              }, data)];

            case 13:
              return [3
              /*break*/
              , 15];

            case 14:
              return [2
              /*return*/
              , {
                status: -1,
                message: rdata.message
              }];

            case 15:
              return [2
              /*return*/
              ];
          }
        });
      });
    },

    /**
     * 获取活动广告
     * @param {String} activiyId 活动id
     * @param {String} adType index/sign_in/team_manager
     */
    getActivityAd: function getActivityAd(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          adType = _b.adType,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, data;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (state.activityAd[activityId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/footer_images', {
                params: {
                  id: activityId,
                  type: adType
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('setActivityAd', {
                  activityId: activityId,
                  adType: adType,
                  data: data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得战队邀请卡
     *
     * @param {string} activityId
     */
    getPersonalInviteCard: function getPersonalInviteCard(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var temp, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              temp = state.personalInviteCard[activityId];

              if (temp && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/get_personal_invite_card_sync', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setPersonalInviteCard', {
                  activityId: activityId,
                  card: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getTermCard: function getTermCard(context, activityId) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              // return {
              //     status: 0,
              //     data: {
              //         url: 'https://growth-test.oss-cn-beijing.aliyuncs.com/material/image/2021-02-15/182927-ZLxRF2.jpeg'
              //     }
              // }
              if (!activityId) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/term_card', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /** 总招募数据 */
    getRecruitStat: function getRecruitStat(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/monitor/recruit_stats', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setRecruitStat', {
                  activityId: activityId,
                  recruitStat: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取锦囊接口
     */
    getTipsList: function getTipsList(_a, activityId) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var temp, response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              temp = state.activityTipsMap[activityId];

              if (temp) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/tips', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setActivityTipsMap', {
                  activityId: activityId,
                  list: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得话术
     */
    getShareWord: function getShareWord(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          kind = _b.kind;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/speeches', {
                params: {
                  id: activityId,
                  kind: kind
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setShareWord', {
                  activityId: activityId,
                  kind: kind,
                  shareWord: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得成就卡
     */
    getSignInCard: function getSignInCard(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var signInId = _b.signInId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/sign_in_card', {
                params: {
                  id: signInId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取活动礼包
     * @param {String} activiyId 活动id
     */
    getGift: function getGift(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, data;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (state.activityGift[activityId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/gift/optional_gift_list', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                data = rdata.data;
                commit('setActivityGift', {
                  activityId: activityId,
                  data: data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 确认选择礼包
     * @param {String} activiyId 活动id
     * @param {Number} giftId 礼品id
     */
    chooseGift: function chooseGift(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          giftId = _b.giftId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/gift/choose_optional_gift', {
                activity_id: activityId,
                gift_id: giftId
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得category列表
     */
    getCategoryList: function getCategoryList(_a, activityId) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/question_categories', {
                params: {
                  id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setCategoryList', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getQuestionList: function getQuestionList(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          categoryId = _b.categoryId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.questionList[categoryId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/question_and_answers', {
                params: {
                  id: activityId,
                  category_id: categoryId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setQuestionList', {
                  categoryId: categoryId,
                  questionList: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /** 退款 */
    participationRefund: function participationRefund(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          reason = _b.reason;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/refund', {
                activity_id: activityId,
                reason: reason
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取完赛的总结数据
     * @param {} activityId 活动id
     * @param {} userId 没有uid的情况下，将默认返回自己的数据
     */
    getSummary: function getSummary(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          userId = _b.userId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (!state.achievementMap[activityId]) {
                Vue.set(state.achievementMap, activityId, {});
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/summary', {
                params: {
                  user_id: userId,
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setAchievementMap', {
                  activityId: activityId,
                  userId: userId,
                  summary: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 更新testimonial
     */
    updateTestimonial: function updateTestimonial(context, _a) {
      var activityId = _a.activityId,
          userId = _a.userId,
          content = _a.content;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/create_recollection', {
                activity_id: activityId,
                user_id: userId,
                content: content
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取用户是否报名
     */
    getUserParticipation: function getUserParticipation(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          userId = _b.userId;
      return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/user_has_sign_up', {
                params: {
                  activity_id: activityId,
                  user_id: userId
                }
              })];

            case 1:
              response = _c.sent();
              return [2
              /*return*/
              , response.data];
          }
        });
      });
    },

    /**
     * 针对于已经报名，但还没加入战队的用户
     */
    joinTeam: function joinTeam(_a, _b) {
      var dispatch = _a.dispatch;
      var activityId = _b.activityId,
          teamId = _b.teamId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/join_team', {
                activity_id: activityId,
                team_id: teamId
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              if (!(rdata.status === 0)) return [3
              /*break*/
              , 3];
              return [4
              /*yield*/
              , dispatch('getBasicInfo', {
                activityId: activityId,
                forceUpdate: true
              })];

            case 2:
              _c.sent();

              _c.label = 3;

            case 3:
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取第十届完赛的总结数据
     * @param {} userId 没有uid的情况下，将默认返回自己的数据
     */
    getReport10: function getReport10(_a, userId) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/finish_report/report_10', {
                params: {
                  user_id: userId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setReport10', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得完赛成就卡
     */
    getReport10Card: function getReport10Card(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/finish_report/card_10')];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取第11届完赛的总结数据
     * @param {} userId 没有uid的情况下，将默认返回自己的数据
     */
    getReport11: function getReport11(_a, userId) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/finish_report/report_11', {
                params: {
                  user_id: userId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setReport11', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得完赛成就卡
     */
    getReport11Card: function getReport11Card(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/finish_report/card_11')];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取第11届完赛的总结数据
     * @param {} userId 没有uid的情况下，将默认返回自己的数据
     */
    getFinishReport: function getFinishReport(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          userId = _b.userId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/finish_report/report', {
                params: {
                  activity_id: activityId,
                  user_id: userId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setReport11', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得完赛成就卡
     */
    getFinishCard: function getFinishCard(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/finish_report/card', {
                params: {
                  activity_id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取用户肖像
     */
    getRunners: function getRunners(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          offset = _b.offset,
          count = _b.count,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var end, response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (state.runners.requesting || state.runners.loaded && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (offset === 0 && forceUpdate) {
                state.runners.list = [];
                state.runners.loaded = false;
                state.runners.requesting = false;
              }

              end = offset + count;

              if (end <= state.runners.list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < state.runners.list.length) {
                offset = state.runners.list.length;
                count = end - offset;
              }

              commit('setRunnersRequest', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/user_avatars', {
                params: {
                  activity_id: activityId,
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setRunners', rdata.data);

                if (rdata.data.length < count) {
                  commit('setRunnersLoaded', true);
                }
              }

              commit('setRunnersRequest', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取用户当前队伍
     */
    getCurrentTeam: function getCurrentTeam(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var userId = _b.userId,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.currentTeam[userId] && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/participation/current_team', {
                params: {
                  user_id: userId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setCurrentTeam', {
                  userId: userId,
                  team: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取跑友故事
     */
    getStory: function getStory(context, _a) {
      var offset = _a.offset,
          count = _a.count,
          forceUpdate = _a.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (context.state.story && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/activity/story', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setStory', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    deductionCodeCheck: function deductionCodeCheck(context, _a) {
      var code = _a.code,
          activity_id = _a.activity_id;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/deduction_code/check', {
                params: {
                  code: code,
                  activity_id: activity_id
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;